// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Attendance Page - Beautiful Styles
   ============================================ */

.attendance-page {
  padding: 20px;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8f5e9 100%);
}

/* ============================================
   Stats Grid
   ============================================ */

.attendance-stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 25px;
}

.stat-card-beautiful {
  background: white;
  border-radius: 16px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.stat-card-beautiful:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
}

.stat-card-beautiful .stat-icon {
  width: 55px;
  height: 55px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-card-beautiful .stat-icon i {
  font-size: 24px;
  color: white;
}

.stat-card-beautiful.present .stat-icon {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
}

.stat-card-beautiful.absent .stat-icon {
  background: linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%);
}

.stat-card-beautiful.holiday .stat-icon {
  background: linear-gradient(135deg, #f7971e 0%, #ffd200 100%);
}

.stat-card-beautiful.total .stat-icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.stat-info {
  display: flex;
  flex-direction: column;
}

.stat-number {
  font-size: 28px;
  font-weight: 700;
  color: #333;
  line-height: 1;
}

.stat-label {
  font-size: 13px;
  color: #888;
  margin-top: 4px;
}

/* ============================================
   Controls Card
   ============================================ */

.attendance-controls-card {
  border: none;
  border-radius: 16px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 25px;
}

.month-picker-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  background: #f8f9fa;
  border-radius: 12px;
  padding: 5px 15px;
}

.month-picker-wrapper i {
  color: #11998e;
  font-size: 18px;
  margin-right: 10px;
}

.month-picker-beautiful {
  border: none;
  background: transparent;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  padding: 10px 0;
  cursor: pointer;
  outline: none;
  width: 150px;
}

.legend-container {
  display: flex;
  justify-content: flex-end;
  gap: 25px;
  flex-wrap: wrap;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #555;
}

.legend-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
}

.legend-dot.present {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
}

.legend-dot.absent {
  background: linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%);
}

.legend-dot.holiday {
  background: linear-gradient(135deg, #f7971e 0%, #ffd200 100%);
}

/* ============================================
   Calendar Card
   ============================================ */

.calendar-card-beautiful {
  border: none;
  border-radius: 16px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 25px;
  overflow: hidden;
}

.calendar-header-row {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
  padding: 15px;
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
}

.calendar-header-row span {
  text-align: center;
  font-weight: 600;
  color: white;
  font-size: 13px;
}

.calendar-grid-beautiful {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
  padding: 15px;
}

.calendar-day-beautiful {
  aspect-ratio: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #f8f9fa;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.calendar-day-beautiful.empty {
  background: transparent;
}

.calendar-day-beautiful .day-number {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.calendar-day-beautiful .day-status-icon {
  font-size: 12px;
  margin-top: 2px;
}

.calendar-day-beautiful.today {
  border: 2px solid #667eea;
}

.calendar-day-beautiful.today .day-number {
  color: #667eea;
}

/* Status Colors */
.calendar-day-beautiful.status-present {
  background: linear-gradient(135deg, rgba(17, 153, 142, 0.15) 0%, rgba(56, 239, 125, 0.15) 100%);
}

.calendar-day-beautiful.status-present .day-number {
  color: #11998e;
}

.calendar-day-beautiful.status-present .day-status-icon {
  color: #11998e;
}

.calendar-day-beautiful.status-absent {
  background: linear-gradient(135deg, rgba(255, 65, 108, 0.15) 0%, rgba(255, 75, 43, 0.15) 100%);
}

.calendar-day-beautiful.status-absent .day-number {
  color: #ff416c;
}

.calendar-day-beautiful.status-absent .day-status-icon {
  color: #ff416c;
}

.calendar-day-beautiful.status-holiday {
  background: linear-gradient(135deg, rgba(247, 151, 30, 0.15) 0%, rgba(255, 210, 0, 0.15) 100%);
}

.calendar-day-beautiful.status-holiday .day-number {
  color: #f7971e;
}

.calendar-day-beautiful.status-holiday .day-status-icon {
  color: #f7971e;
}

.calendar-day-beautiful:hover:not(.empty) {
  transform: scale(1.1);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

/* ============================================
   Records Table Card
   ============================================ */

.records-card-beautiful {
  border: none;
  border-radius: 16px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.records-header {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
  border: none;
  padding: 15px 20px;
}

.records-header h5 {
  color: white;
  margin: 0;
  font-weight: 600;
}

.records-table-wrapper {
  max-height: 400px;
  overflow-y: auto;
}

.records-table-beautiful {
  width: 100%;
  border-collapse: collapse;
}

.records-table-beautiful thead {
  background: #f8f9fa;
  position: sticky;
  top: 0;
  z-index: 1;
}

.records-table-beautiful th {
  padding: 15px 20px;
  text-align: left;
  font-weight: 600;
  color: #555;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.records-table-beautiful tbody tr {
  border-bottom: 1px solid #eee;
  animation: fadeInRow 0.4s ease forwards;
  opacity: 0;
}

@keyframes fadeInRow {
  to {
    opacity: 1;
  }
}

.records-table-beautiful tbody tr:hover {
  background: #f8f9fa;
}

.records-table-beautiful td {
  padding: 15px 20px;
  font-size: 14px;
  color: #333;
}

.status-badge-beautiful {
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
}

.status-badge-beautiful.present {
  background: linear-gradient(135deg, rgba(17, 153, 142, 0.15) 0%, rgba(56, 239, 125, 0.15) 100%);
  color: #11998e;
}

.status-badge-beautiful.absent {
  background: linear-gradient(135deg, rgba(255, 65, 108, 0.15) 0%, rgba(255, 75, 43, 0.15) 100%);
  color: #ff416c;
}

.status-badge-beautiful.holiday {
  background: linear-gradient(135deg, rgba(247, 151, 30, 0.15) 0%, rgba(255, 210, 0, 0.15) 100%);
  color: #e68a00;
}

/* ============================================
   Responsive Styles
   ============================================ */

@media (max-width: 991.98px) {
  .attendance-stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 767.98px) {
  .attendance-page {
    padding: 15px;
  }

  .attendance-stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }

  .stat-card-beautiful {
    padding: 15px;
  }

  .stat-card-beautiful .stat-icon {
    width: 45px;
    height: 45px;
  }

  .stat-card-beautiful .stat-icon i {
    font-size: 20px;
  }

  .stat-number {
    font-size: 22px;
  }

  .stat-label {
    font-size: 12px;
  }

  .legend-container {
    justify-content: center;
    margin-top: 15px;
    gap: 15px;
  }

  .calendar-header-row span {
    font-size: 11px;
  }

  .calendar-grid-beautiful {
    gap: 5px;
    padding: 10px;
  }

  .calendar-day-beautiful {
    border-radius: 8px;
  }

  .calendar-day-beautiful .day-number {
    font-size: 13px;
  }

  .calendar-day-beautiful .day-status-icon {
    font-size: 10px;
  }

  .records-table-beautiful th,
  .records-table-beautiful td {
    padding: 12px 15px;
    font-size: 13px;
  }
}

@media (max-width: 575.98px) {
  .attendance-page {
    padding: 10px;
  }

  .attendance-stats-grid {
    gap: 10px;
  }

  .stat-card-beautiful {
    padding: 12px;
    gap: 10px;
  }

  .stat-card-beautiful .stat-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
  }

  .stat-card-beautiful .stat-icon i {
    font-size: 18px;
  }

  .stat-number {
    font-size: 20px;
  }

  .stat-label {
    font-size: 11px;
  }

  .month-picker-wrapper {
    width: 100%;
    justify-content: center;
  }

  .legend-container {
    gap: 10px;
  }

  .legend-item {
    font-size: 12px;
    gap: 5px;
  }

  .legend-dot {
    width: 12px;
    height: 12px;
  }

  .calendar-header-row {
    padding: 10px;
  }

  .calendar-header-row span {
    font-size: 10px;
  }

  .calendar-grid-beautiful {
    gap: 4px;
    padding: 8px;
  }

  .calendar-day-beautiful .day-number {
    font-size: 11px;
  }

  .calendar-day-beautiful .day-status-icon {
    display: none;
  }

  .records-table-beautiful th,
  .records-table-beautiful td {
    padding: 10px 12px;
    font-size: 12px;
  }

  .status-badge-beautiful {
    padding: 4px 10px;
    font-size: 11px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/dashboards/components/attendance.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;;iDAEiD;;AAEjD;EACE,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,eAAe;EACf,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;;iDAEiD;;AAEjD;EACE,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,aAAa;EACb,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,+FAA+F;AACjG;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8FAA8F;AAChG;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8FAA8F;AAChG;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;;iDAEiD;;AAEjD;EACE,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+FAA+F;EAC/F,cAAc;AAChB;;AAEA;EACE,8FAA8F;EAC9F,cAAc;AAChB;;AAEA;EACE,8FAA8F;EAC9F,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":["/* ============================================\n   Attendance Page - Beautiful Styles\n   ============================================ */\n\n.attendance-page {\n  padding: 20px;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f7fa 0%, #e8f5e9 100%);\n}\n\n/* ============================================\n   Stats Grid\n   ============================================ */\n\n.attendance-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n  margin-bottom: 25px;\n}\n\n.stat-card-beautiful {\n  background: white;\n  border-radius: 16px;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);\n  transition: all 0.3s ease;\n}\n\n.stat-card-beautiful:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);\n}\n\n.stat-card-beautiful .stat-icon {\n  width: 55px;\n  height: 55px;\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.stat-card-beautiful .stat-icon i {\n  font-size: 24px;\n  color: white;\n}\n\n.stat-card-beautiful.present .stat-icon {\n  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);\n}\n\n.stat-card-beautiful.absent .stat-icon {\n  background: linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%);\n}\n\n.stat-card-beautiful.holiday .stat-icon {\n  background: linear-gradient(135deg, #f7971e 0%, #ffd200 100%);\n}\n\n.stat-card-beautiful.total .stat-icon {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.stat-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.stat-number {\n  font-size: 28px;\n  font-weight: 700;\n  color: #333;\n  line-height: 1;\n}\n\n.stat-label {\n  font-size: 13px;\n  color: #888;\n  margin-top: 4px;\n}\n\n/* ============================================\n   Controls Card\n   ============================================ */\n\n.attendance-controls-card {\n  border: none;\n  border-radius: 16px;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);\n  margin-bottom: 25px;\n}\n\n.month-picker-wrapper {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  background: #f8f9fa;\n  border-radius: 12px;\n  padding: 5px 15px;\n}\n\n.month-picker-wrapper i {\n  color: #11998e;\n  font-size: 18px;\n  margin-right: 10px;\n}\n\n.month-picker-beautiful {\n  border: none;\n  background: transparent;\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n  padding: 10px 0;\n  cursor: pointer;\n  outline: none;\n  width: 150px;\n}\n\n.legend-container {\n  display: flex;\n  justify-content: flex-end;\n  gap: 25px;\n  flex-wrap: wrap;\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: #555;\n}\n\n.legend-dot {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n}\n\n.legend-dot.present {\n  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);\n}\n\n.legend-dot.absent {\n  background: linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%);\n}\n\n.legend-dot.holiday {\n  background: linear-gradient(135deg, #f7971e 0%, #ffd200 100%);\n}\n\n/* ============================================\n   Calendar Card\n   ============================================ */\n\n.calendar-card-beautiful {\n  border: none;\n  border-radius: 16px;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);\n  margin-bottom: 25px;\n  overflow: hidden;\n}\n\n.calendar-header-row {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 8px;\n  padding: 15px;\n  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);\n}\n\n.calendar-header-row span {\n  text-align: center;\n  font-weight: 600;\n  color: white;\n  font-size: 13px;\n}\n\n.calendar-grid-beautiful {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 8px;\n  padding: 15px;\n}\n\n.calendar-day-beautiful {\n  aspect-ratio: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  background: #f8f9fa;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.calendar-day-beautiful.empty {\n  background: transparent;\n}\n\n.calendar-day-beautiful .day-number {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n}\n\n.calendar-day-beautiful .day-status-icon {\n  font-size: 12px;\n  margin-top: 2px;\n}\n\n.calendar-day-beautiful.today {\n  border: 2px solid #667eea;\n}\n\n.calendar-day-beautiful.today .day-number {\n  color: #667eea;\n}\n\n/* Status Colors */\n.calendar-day-beautiful.status-present {\n  background: linear-gradient(135deg, rgba(17, 153, 142, 0.15) 0%, rgba(56, 239, 125, 0.15) 100%);\n}\n\n.calendar-day-beautiful.status-present .day-number {\n  color: #11998e;\n}\n\n.calendar-day-beautiful.status-present .day-status-icon {\n  color: #11998e;\n}\n\n.calendar-day-beautiful.status-absent {\n  background: linear-gradient(135deg, rgba(255, 65, 108, 0.15) 0%, rgba(255, 75, 43, 0.15) 100%);\n}\n\n.calendar-day-beautiful.status-absent .day-number {\n  color: #ff416c;\n}\n\n.calendar-day-beautiful.status-absent .day-status-icon {\n  color: #ff416c;\n}\n\n.calendar-day-beautiful.status-holiday {\n  background: linear-gradient(135deg, rgba(247, 151, 30, 0.15) 0%, rgba(255, 210, 0, 0.15) 100%);\n}\n\n.calendar-day-beautiful.status-holiday .day-number {\n  color: #f7971e;\n}\n\n.calendar-day-beautiful.status-holiday .day-status-icon {\n  color: #f7971e;\n}\n\n.calendar-day-beautiful:hover:not(.empty) {\n  transform: scale(1.1);\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n}\n\n/* ============================================\n   Records Table Card\n   ============================================ */\n\n.records-card-beautiful {\n  border: none;\n  border-radius: 16px;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n}\n\n.records-header {\n  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);\n  border: none;\n  padding: 15px 20px;\n}\n\n.records-header h5 {\n  color: white;\n  margin: 0;\n  font-weight: 600;\n}\n\n.records-table-wrapper {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.records-table-beautiful {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.records-table-beautiful thead {\n  background: #f8f9fa;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.records-table-beautiful th {\n  padding: 15px 20px;\n  text-align: left;\n  font-weight: 600;\n  color: #555;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.records-table-beautiful tbody tr {\n  border-bottom: 1px solid #eee;\n  animation: fadeInRow 0.4s ease forwards;\n  opacity: 0;\n}\n\n@keyframes fadeInRow {\n  to {\n    opacity: 1;\n  }\n}\n\n.records-table-beautiful tbody tr:hover {\n  background: #f8f9fa;\n}\n\n.records-table-beautiful td {\n  padding: 15px 20px;\n  font-size: 14px;\n  color: #333;\n}\n\n.status-badge-beautiful {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 14px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.status-badge-beautiful.present {\n  background: linear-gradient(135deg, rgba(17, 153, 142, 0.15) 0%, rgba(56, 239, 125, 0.15) 100%);\n  color: #11998e;\n}\n\n.status-badge-beautiful.absent {\n  background: linear-gradient(135deg, rgba(255, 65, 108, 0.15) 0%, rgba(255, 75, 43, 0.15) 100%);\n  color: #ff416c;\n}\n\n.status-badge-beautiful.holiday {\n  background: linear-gradient(135deg, rgba(247, 151, 30, 0.15) 0%, rgba(255, 210, 0, 0.15) 100%);\n  color: #e68a00;\n}\n\n/* ============================================\n   Responsive Styles\n   ============================================ */\n\n@media (max-width: 991.98px) {\n  .attendance-stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 767.98px) {\n  .attendance-page {\n    padding: 15px;\n  }\n\n  .attendance-stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 15px;\n  }\n\n  .stat-card-beautiful {\n    padding: 15px;\n  }\n\n  .stat-card-beautiful .stat-icon {\n    width: 45px;\n    height: 45px;\n  }\n\n  .stat-card-beautiful .stat-icon i {\n    font-size: 20px;\n  }\n\n  .stat-number {\n    font-size: 22px;\n  }\n\n  .stat-label {\n    font-size: 12px;\n  }\n\n  .legend-container {\n    justify-content: center;\n    margin-top: 15px;\n    gap: 15px;\n  }\n\n  .calendar-header-row span {\n    font-size: 11px;\n  }\n\n  .calendar-grid-beautiful {\n    gap: 5px;\n    padding: 10px;\n  }\n\n  .calendar-day-beautiful {\n    border-radius: 8px;\n  }\n\n  .calendar-day-beautiful .day-number {\n    font-size: 13px;\n  }\n\n  .calendar-day-beautiful .day-status-icon {\n    font-size: 10px;\n  }\n\n  .records-table-beautiful th,\n  .records-table-beautiful td {\n    padding: 12px 15px;\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .attendance-page {\n    padding: 10px;\n  }\n\n  .attendance-stats-grid {\n    gap: 10px;\n  }\n\n  .stat-card-beautiful {\n    padding: 12px;\n    gap: 10px;\n  }\n\n  .stat-card-beautiful .stat-icon {\n    width: 40px;\n    height: 40px;\n    border-radius: 10px;\n  }\n\n  .stat-card-beautiful .stat-icon i {\n    font-size: 18px;\n  }\n\n  .stat-number {\n    font-size: 20px;\n  }\n\n  .stat-label {\n    font-size: 11px;\n  }\n\n  .month-picker-wrapper {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .legend-container {\n    gap: 10px;\n  }\n\n  .legend-item {\n    font-size: 12px;\n    gap: 5px;\n  }\n\n  .legend-dot {\n    width: 12px;\n    height: 12px;\n  }\n\n  .calendar-header-row {\n    padding: 10px;\n  }\n\n  .calendar-header-row span {\n    font-size: 10px;\n  }\n\n  .calendar-grid-beautiful {\n    gap: 4px;\n    padding: 8px;\n  }\n\n  .calendar-day-beautiful .day-number {\n    font-size: 11px;\n  }\n\n  .calendar-day-beautiful .day-status-icon {\n    display: none;\n  }\n\n  .records-table-beautiful th,\n  .records-table-beautiful td {\n    padding: 10px 12px;\n    font-size: 12px;\n  }\n\n  .status-badge-beautiful {\n    padding: 4px 10px;\n    font-size: 11px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
